/*       */

import { loadData, mutateData } from 'app/utils/redux/action-utils';
import OptionsBuilder from 'app/utils/api/OptionsBuilder';
import { getAvatar } from 'app/utils/avatar/avatar';
import { PUBLIC_TEAM_ID, settingsEntityType } from 'app/config/config';
import { get } from 'app/utils/lo/lo';
import {
    extractSearchRecords,
    extractLazyLoadData,
    getResourceIdConfig,
    normalizeWorkspacePayload,
    WORKSPACE_RESOURCES_QUERY_CONFIG,
    ENTITY_BASED_TYPES,
    buildEntityResourceFilterBy
} from 'app/utils/workspace/workspaceUtils';

import updateWorkspaceMutation from 'graphql/workspaces/updateWorkspaceMutation';
import createWorkspaceMutation from 'graphql/workspaces/createWorkspaceMutation';
import loadWorkspacesQuery from 'graphql/workspaces/loadWorkspacesQuery';
import loadWorkspaceQuery from 'graphql/workspaces/loadWorkspaceQuery';
import workspaceHistoryQuery from 'graphql/workspaces/workspaceHistoryQuery';
import removeWorkspaceTeamsMutation from 'graphql/workspaces/removeWorkspaceTeamsMutation';
import addWorkspaceTeamsMutation from 'graphql/workspaces/addWorkspaceTeamsMutation';
import removeWorkspaceUsersMutation from 'graphql/workspaces/removeWorkspaceUsersMutation';
import addWorkspaceUsersMutation from 'graphql/workspaces/addWorkspaceUsersMutation';
import { loadWorkspacePermissionsQuery, workspaceEntityResourcesQuery } from 'graphql/workspaces/loadResourceListQuery';
import {
    loadWorkspacePermissionsLazyQuery,
    loadWorkspaceEntityResourcesByTypeLazyQuery,
} from 'graphql/workspaces/loadWorkspaceLazyResourcesQueries';

import loadWorkspaceUsersByPrivateTeam from 'graphql/workspaces/loadWorkspaceUsersByPrivateTeam';
import { loadWorkspaceClassResourceIdsQuery, loadWorkspaceEntityResourceIdsQuery, loadWorkspaceTeamIdsQuery, loadWorkspaceEntityResourceIdsByTypeQuery } from 'graphql/workspaces/loadWorkspaceResourceIdsQueries';
import addWorkspaceResourceMutation from 'graphql/workspaces/addWorkspaceResourceMutation';
import removeWorkspaceResourceMutation from 'graphql/workspaces/removeWorkspaceResourceMutation';
import addWorkspaceClassResourcesMutation from 'graphql/workspaces/addWorkspaceClassResourcesMutation';
import removeWorkspaceClassResourcesMutation from 'graphql/workspaces/removeWorkspaceClassResourcesMutation';
import addWorkspaceClassesMutation from 'graphql/workspaces/addWorkspaceClassesMutation';
import removeWorkspaceClassesMutation from 'graphql/workspaces/removeWorkspaceClassesMutation';
import { addWorkspaceOwnersMutation, removeWorkspaceOwnersMutation } from 'graphql/workspaces/workspaceOwnerMutations';
import loadAvatarQuery from 'graphql/workspaces/loadAvatarQuery';
import loadWorkspacesTypeaheadQuery from 'graphql/workspaces/loadWorkspacesTypeaheadQuery';
import { defaultRole } from 'app/config/rolesConfig';
import leaveWorkspaceMutation from 'graphql/workspaces/leaveWorkspaceMutation';
import { graphql } from 'graphql/client';
import { getEntityType } from 'app/config/workspaceResourceTypesConfig';

export const LOAD_WORKSPACES_STARTED = '@@affectli/admin/workspaces/LOAD_WORKSPACES_STARTED';
export const LOAD_WORKSPACES = '@@affectli/admin/workspaces/LOAD_WORKSPACES';

export const LOAD_WORKSPACE_STARTED = '@@affectli/admin/workspaces/LOAD_WORKSPACE_STARTED';
export const LOAD_WORKSPACE = '@@affectli/admin/workspaces/LOAD_WORKSPACE';

export const CREATE_WORKSPACE_STARTED = '@@affectli/admin/workspaces/CREATE_WORKSPACE_STARTED';
export const CREATE_WORKSPACE = '@@affectli/admin/workspaces/CREATE_WORKSPACE';

export const LOAD_RESOURCE_LIST_STARTED = '@@affectli/admin/workspaces/LOAD_RESOURCE_LIST_STARTED';
export const LOAD_RESOURCE_LIST = '@@affectli/admin/workspaces/LOAD_RESOURCE_LIST';

export const ADD_WORKSPACE_CLASSES_STARTED = '@@affectli/admin/workspaces/ADD_WORKSPACE_CLASSES_STARTED';
export const ADD_WORKSPACE_CLASSES = '@@affectli/admin/workspaces/ADD_WORKSPACE_CLASSES';

export const REMOVE_WORKSPACE_CLASSES_STARTED = '@@affectli/admin/workspaces/REMOVE_WORKSPACE_CLASSES_STARTED';
export const REMOVE_WORKSPACE_CLASSES = '@@affectli/admin/workspaces/REMOVE_WORKSPACE_CLASSES';

export const LOAD_AVATAR_STARTED = '@@affectli/admin/workspaces/LOAD_AVATAR_STARTED';
export const LOAD_AVATAR = '@@affectli/admin/workspaces/LOAD_AVATAR';

export const LOAD_WORKSPACES_TYPEAHEAD_STARTED = '@@affectli/admin/workspaces/LOAD_WORKSPACES_TYPEAHEAD_STARTED';
export const LOAD_WORKSPACES_TYPEAHEAD = '@@affectli/admin/workspaces/LOAD_WORKSPACES_TYPEAHEAD';

export const LOAD_WORKSPACE_HISTORY_STARTED = '@@affectli/admin/workspaces/LOAD_WORKSPACE_HISTORY_STARTED';
export const LOAD_WORKSPACE_HISTORY = '@@affectli/admin/workspaces/LOAD_WORKSPACE_HISTORY';

export const LOAD_WORKSPACE_USERS_STARTED = '@@affectli/admin/workspaces/LOAD_WORKSPACE_USERS_STARTED';
export const LOAD_WORKSPACE_USERS = '@@affectli/admin/workspaces/LOAD_WORKSPACE_USERS';

export const LOAD_WORKSPACE_RESOURCES_STARTED = '@@affectli/admin/workspaces/LOAD_WORKSPACE_RESOURCES_STARTED';
export const LOAD_WORKSPACE_RESOURCES = '@@affectli/admin/workspaces/LOAD_WORKSPACE_RESOURCES';

export const LOAD_WORKSPACE_PERMISSIONS_STARTED = '@@affectli/admin/workspaces/LOAD_WORKSPACE_PERMISSIONS_STARTED';
export const LOAD_WORKSPACE_PERMISSIONS = '@@affectli/admin/workspaces/LOAD_WORKSPACE_PERMISSIONS';

export const LOAD_ADDED_RESOURCE_IDS_STARTED = '@@affectli/admin/workspaces/LOAD_ADDED_RESOURCE_IDS_STARTED';
export const LOAD_ADDED_RESOURCE_IDS = '@@affectli/admin/workspaces/LOAD_ADDED_RESOURCE_IDS';

export const loadWorkspaces = ({ options }) => {
    const variables = new OptionsBuilder(options)
        .filter({ field: 'isSystem', op: '=', value: false })
        .defaultStartStopIndexs(0, 30)
        .build();
    return loadData(LOAD_WORKSPACES_STARTED, LOAD_WORKSPACES, loadWorkspacesQuery)(variables);
};

export const loadWorkspace = id => loadData(LOAD_WORKSPACE_STARTED, LOAD_WORKSPACE, loadWorkspaceQuery, normalizeWorkspacePayload)({ id });

export const createWorkspace = record => mutateData(CREATE_WORKSPACE_STARTED, CREATE_WORKSPACE, createWorkspaceMutation, 'Workspace added.')({ record });

export const updateWorkspace = (record, message = 'Workspace updated.') => {
    return mutateData(LOAD_WORKSPACE_STARTED, LOAD_WORKSPACE, updateWorkspaceMutation, message)({ record });
};

export const addWorkspaceTeams = (id, teamMembers, successMessage) => {
    return mutateData(
        LOAD_WORKSPACE_STARTED,
        LOAD_WORKSPACE,
        addWorkspaceTeamsMutation,
        successMessage ? successMessage : `Team${
            teamMembers && teamMembers.length > 1 ? 's' : ''
        } added to workspace.`
    )({ id, teamMembers });
};

export const removeWorkspaceTeams = (id, teams) => {
    return mutateData(
        LOAD_WORKSPACE_STARTED,
        LOAD_WORKSPACE,
        removeWorkspaceTeamsMutation,
        `Team${teams && teams.length > 1 ? 's' : ''} removed from workspace.`
    )({ id, teams });
};

export const addWorkspaceUsers = (id, userMembers, successMessage) => {
    return mutateData(
        LOAD_WORKSPACE_STARTED,
        LOAD_WORKSPACE,
        addWorkspaceUsersMutation,
        successMessage ? successMessage : `User${
            userMembers && userMembers.length > 1 ? 's' : ''
        } added to workspace.`
    )({ id, userMembers });
};

export const removeWorkspaceUsers = (id, users) => {
    return mutateData(
        LOAD_WORKSPACE_STARTED,
        LOAD_WORKSPACE,
        removeWorkspaceUsersMutation,
        `User${users && users.length > 1 ? 's' : ''} removed from workspace.`
    )({ id, users });
};

export const leaveWorkspace = id => {
    return mutateData('leaveWorkspaceStarted', 'leaveWorkspace', leaveWorkspaceMutation)({ id });
};

export const addWorkspaceOwners = (id, owners) => {
    return mutateData(
        LOAD_WORKSPACE_STARTED,
        LOAD_WORKSPACE,
        addWorkspaceOwnersMutation,
        `Owner${owners && owners.length > 1 ? 's' : ''} added to workspace.`
    )({ id, owners });
};

export const removeWorkspaceOwners = (id, owners) => {
    return mutateData(
        LOAD_WORKSPACE_STARTED,
        LOAD_WORKSPACE,
        removeWorkspaceOwnersMutation,
        `Owner${owners && owners.length > 1 ? 's' : ''} removed from workspace.`
    )({ id, owners });
};

const _modifyResourcesPayload = (type, showActiveClasses) => payload => {
    if (type === 'primaryClass') {
        let { records: classes } = payload || {};
        let records = [];
        classes = classes?.filter(({ uri }) => uri !== 'permission' && uri !== settingsEntityType);
        if (showActiveClasses) {
            records = classes?.filter(cls => cls?.active);
        } else {
            records = classes?.filter(cls => cls?.active && !cls.hidden);
        }
        return { ...payload, records };
    }
    if (type === 'eventtype') {
        const { records: eventTypes } = payload || {};
        let records = [];
        if (eventTypes?.length) {
            records = eventTypes?.map(et => ({ ...et, uri: 'event' }));
        }
        return { ...payload, records };
    }
    return payload;
};

export const loadResourceList = (options = {}, type, applicableOn = [], isEntityQuery = false, showActiveClasses = false) => (dispatch, getState) => {
    if (type === 'permission') return dispatch(loadWorkspacePermissionsList());
    const addedResourcesIds = get(getState(), 'admin.workspaces.addedResourceIds.data', []);
    if (addedResourcesIds?.length) {
        options.filterBy?.push({ field: 'id', op: 'not in', value: addedResourcesIds });
    }
    const variables = new OptionsBuilder(options).defaultStartStopIndexs(0, 30);
    const isAdmin = get(getState(), 'user.profile.isAdmin', false);
    if (!isAdmin && !['team', 'workspace', 'user', 'eventtype', 'event', 'relationDefinition', 'primaryClass'].includes(type)) {
        variables.filter({
            or: [
                { field: 'workspaces.role', op: '=', value: defaultRole },
                { field: 'workspaces.workspace.teams.role', op: '=', value: defaultRole },
                { field: 'workspaces.workspace.teams.team.users.role', op: '=', value: defaultRole },
            ],
        });
    }
    if (type === 'class' && applicableOn && applicableOn.length) {
        variables.filter({ field: 'applicableOn', op: 'contains', value: applicableOn });
    } else if (['person', 'team', 'workspace', 'user'].includes(type)) {
        if (type === 'team')
            variables.filter({
                or: [
                    { field: 'id', op: '=', value: PUBLIC_TEAM_ID },
                    { field: 'isSystem', op: '=', value: false },
                ],
            });
        else variables.filter({ field: 'isSystem', op: '=', value: false });
    } else if (type === 'permission') {
        variables.filter({ field: 'active', op: '=', value: true });
    }
    const setVariables = (isEntityQuery || type !== 'user') && {
        ...variables.build(),
        startIndex: options.startIndex,
    };
    return loadData(
        LOAD_RESOURCE_LIST_STARTED,
        LOAD_RESOURCE_LIST,
        workspaceEntityResourcesQuery(type, isEntityQuery),
        _modifyResourcesPayload(type, showActiveClasses)
    )(setVariables)(dispatch, getState);
};


export const loadWorkspacePermissionsList = () => (dispatch, getState) => {
    dispatch({ type: LOAD_RESOURCE_LIST_STARTED });
    return graphql
        .query({
            query: loadWorkspacePermissionsQuery,
            variables: { filterBy: [{ field: 'active', op: '=', value: true }] },
            fetchPolicy: 'no-cache',
        })
        .then(response => {
            const { permissionRecords, systemSettingRecords } = response?.data || {};
            const records = [...(permissionRecords || []), ...(systemSettingRecords || [])].filter(f => f?.active);
            dispatch({ type: LOAD_RESOURCE_LIST, payload: { records, count: records?.length } });
        })
        .catch(error => {
            dispatch({ type: LOAD_RESOURCE_LIST, payload: error, error: true });
        });
};

export const clearResourcesList = () => dispatch => {
    dispatch({ type: LOAD_RESOURCE_LIST });
    dispatch({ type: LOAD_ADDED_RESOURCE_IDS, payload: null });
};

export const addWorkspaceResources = (id, list, type) => {
    const variables = { id };
    let query = '';
    if (type === 'class') {
        query = addWorkspaceClassResourcesMutation;
        variables.classes = (list || []).map(({ id }) => id);
    } else {
        query = addWorkspaceResourceMutation;
        variables.entities = (list || []).map(({ id, type }) => ({ id, type }));
    }
    return mutateData(LOAD_WORKSPACE_STARTED, LOAD_WORKSPACE, query, `Resource${list && list.length > 1 ? 's' : ''} added to workspace.`)(variables);
};

export const removeWorkspaceResources = (id, list, type) => {
    const variables = { id };
    let query = '';
    if (type === 'class') {
        query = removeWorkspaceClassResourcesMutation;
        variables.classes = (list || []).map(({ id }) => id);
    } else {
        query = removeWorkspaceResourceMutation;
        variables.entities = (list || []).map(({ id, type }) => ({ id, type }));
    }
    return mutateData(LOAD_WORKSPACE_STARTED, LOAD_WORKSPACE, query, `Resource${list && list.length > 1 ? 's' : ''} removed from workspace.`)(variables);
};

export const addWorkspaceClasses = (id, classes) => (dispatch, getState) => {
    return mutateData(
        ADD_WORKSPACE_CLASSES_STARTED,
        ADD_WORKSPACE_CLASSES,
        addWorkspaceClassesMutation,
        `Class${classes && classes.length > 1 ? 'es' : ''} added to workspace.`
    )({ id, classes })(dispatch, getState).then(result => {
        if (result instanceof Error) return;
        result && result.id && dispatch({ type: LOAD_WORKSPACE, payload: result });
    });
};

export const removeWorkspaceClasses = (id, classes) => (dispatch, getState) => {
    return mutateData(
        REMOVE_WORKSPACE_CLASSES_STARTED,
        REMOVE_WORKSPACE_CLASSES,
        removeWorkspaceClassesMutation,
        `Class${classes && classes.length > 1 ? 'es' : ''} removed workspace.`
    )({ id, classes })(dispatch, getState).then(result => {
        if (result instanceof Error) return;
        result && result.id && dispatch({ type: LOAD_WORKSPACE, payload: result });
    });
};
export const loadAvatar = id => (dispatch, getState) => {
    const avatar = getAvatar(getState(), 'workspace', id);
    if (avatar && (avatar.isLoading || avatar.loadedAt > Date.now() - 60 * 60 * 1000)) {
        // if we are loding the avatar or it is already loaded and it is stored less then 1 hour ago
        // we return the data in the state without calling the service
        return Promise.resolve(avatar);
    }
    return loadData(LOAD_AVATAR_STARTED, LOAD_AVATAR, loadAvatarQuery)({ id })(dispatch, getState);
};

export const loadWorkspacesTypeahead = loadData(LOAD_WORKSPACES_TYPEAHEAD_STARTED, LOAD_WORKSPACES_TYPEAHEAD, loadWorkspacesTypeaheadQuery);

export const loadWorkspaceHistory = (id, options) => (dispatch, getState) => {
    const variables = new OptionsBuilder(options).filter({ field: 'workspace.id', op: '=', value: id }).build();
    return loadData(LOAD_WORKSPACE_HISTORY_STARTED, LOAD_WORKSPACE_HISTORY, workspaceHistoryQuery)(variables)(dispatch, getState);
};

export const loadWorkspaceUsers = (workspaceId) => dispatch => {
    dispatch({ type: LOAD_WORKSPACE_USERS_STARTED });
    return graphql
        .query({
            query: loadWorkspaceUsersByPrivateTeam,
            variables: { workspaceId },
            fetchPolicy: 'no-cache',
        })
        .then(response => {
            const result = get(response, 'data.result', []);
            const privateTeam = result[0]; // Should only be one private/system team
            const users = get(privateTeam, 'team.users', []);
            const payload = {
                records: users.map(({ user, role }) => ({ ...user, role }))
            }
            dispatch({ type: LOAD_WORKSPACE_USERS, payload });
            return payload;
        })
        .catch(error => {
            dispatch({ type: LOAD_WORKSPACE_USERS, payload: error, error: true });
            return error;
        });
};

/**
 * Load all workspace permissions separately from workspace details
 * This action is fired alongside loadWorkspace() to fetch permissions independently
 * Uses keepDataAtStart pattern in reducer to prevent clearing old data
 * @param {string} id - The workspace ID
 * @returns {Promise} Promise that resolves with permissions data
 */
export const loadWorkspacePermissions = (id) => (dispatch) => {
    dispatch({ type: LOAD_WORKSPACE_PERMISSIONS_STARTED });

    return graphql
        .query({
            query: loadWorkspacePermissionsLazyQuery,
            variables: { id },
            fetchPolicy: 'no-cache',
        })
        .then(response => {
            const permissionsData = get(response, 'data.workspace', []);
            const permissions = permissionsData.map(({entity}) => entity);
            const payload = { records: permissions };

            dispatch({ type: LOAD_WORKSPACE_PERMISSIONS, payload });
            return payload;
        })
        .catch(error => {
            dispatch({ type: LOAD_WORKSPACE_PERMISSIONS, payload: error, error: true });
            return error;
        });
};


/**
 * Unified action to load workspace resources based on type
 * Automatically handles entity-based and workspace-based resource types
 * @param {string} id - The workspace ID
 * @param {string} resourceType - The resource type (class, entity, team, system_task, system_process, script)
 * @param {object} options - Options for pagination and filtering
 */
export const loadWorkspaceResources = (id, resourceType, options = {}) => (dispatch, getState) => {
    const { startIndex = 0, stopIndex = 30, searchValue: searchQuery } = options;
    const useSearchQuery = searchQuery || resourceType === 'team'; // Always use search query for team to filter system teams
    // Determine which query and variables to use based on resource type
    let query;
    let variables = { startIndex, stopIndex };

    if (ENTITY_BASED_TYPES.includes(resourceType)) {
        const entityType = getEntityType(resourceType);

        // Handle entity-based resource types (task, process, system_task, system_process, script...)
        const filterBy = buildEntityResourceFilterBy(id, entityType, searchQuery);
        query = loadWorkspaceEntityResourcesByTypeLazyQuery;
        variables = { ...variables, filterBy };
    } else {
        // Handle workspace-based resource types (class, team)
        const config = WORKSPACE_RESOURCES_QUERY_CONFIG[resourceType];
        if (!config) {
            console.error(`Unknown resource type: ${resourceType}`);
            return Promise.reject(new Error(`Unknown resource type: ${resourceType}`));
        }
        query = useSearchQuery ? config.search : config.lazy;
        variables = useSearchQuery
            ? { ...variables, id, searchQuery: searchQuery || '', ilikeSearchQuery: searchQuery ? `%${searchQuery}%` : '%%' }
            : { ...variables, id, };
    }

    // Use loadData with modifyPayload to extract and transform the response
    const modifyPayload = (response) => {
        const extractFn = useSearchQuery ? extractSearchRecords : extractLazyLoadData;
        const result = extractFn(response, resourceType);
        const { records, count = 0 } = result;
        return { 
            records, 
            count, 
            startIndex,
        };
    };

    return loadData(
        LOAD_WORKSPACE_RESOURCES_STARTED,
        LOAD_WORKSPACE_RESOURCES,
        query,
        modifyPayload
    )({ ...variables, resourceType })(dispatch, getState);
};

/**
 * Load added resource IDs for modal session (to exclude from search results)
 * Call this when modal opens to cache workspace resource IDs
 * Uses loadData helper with modifyPayload to fetch and transform IDs in one action
 *
 * @param {string} workspaceId - The workspace ID
 * @param {string} resourceType - The resource type ('class', 'primaryClass', 'team', 'task', 'process', 'script')
 * @returns {Promise} Promise that resolves with array of ID strings
 */
export const loadAddedResourceIds = (workspaceId, resourceType) => (dispatch, getState) => {
    const queries = {
        loadWorkspaceClassResourceIdsQuery,
        loadWorkspaceEntityResourceIdsQuery,
        loadWorkspaceTeamIdsQuery,
        loadWorkspaceEntityResourceIdsByTypeQuery
    };

    const config = getResourceIdConfig(resourceType, queries);

    if (!config) {
        console.error(`Invalid resource type: ${resourceType}. Expected 'class', 'primaryClass', 'team', 'task', 'process', or 'script'.`);
        dispatch({ type: LOAD_ADDED_RESOURCE_IDS, payload: [], error: true });
        return Promise.resolve([]);
    }

    const { query, resourceKey, extractor, entityType } = config;
    const type = entityType || resourceType;
    // Build variables based on resource type
    const variables = ENTITY_BASED_TYPES.includes(resourceType)
        ? { filterBy: buildEntityResourceFilterBy(workspaceId, type) }
        : { id: workspaceId };

    // Use loadData with modifyPayload for both entity-based and workspace-based types
    const modifyPayload = (response) => {
        const resources = get(response, resourceKey, []);
        return extractor(resources);
    };

    return loadData(
        LOAD_ADDED_RESOURCE_IDS_STARTED,
        LOAD_ADDED_RESOURCE_IDS,
        query,
        modifyPayload
    )(variables)(dispatch, getState);
};

